import {
  BaseFlowModel,
  BaseFlowStepData,
} from '@kinet-open-network/client/flows/data-access';
import { BaseModel } from '@kinet-open-network/client/shared/data-access/model';
import { ICustomer } from '@kinet-open-network/shared/data-access/model';
import {
  ChangePriceFlowStatus,
  IFlowChangePriceItem,
  IFlowChangePrices,
  IFlowChangePricesStepData,
} from '@kinet-open-network/shared/data-access/model-pbgas';
import { VatRateType } from '@kinet-open-network/shared/util';
import { Type } from 'class-transformer';

export class FlowChangePrices
  extends BaseFlowModel<FlowChangePrices, 'ChangePrice'>
  implements IFlowChangePrices
{
  static override readonly modelName = 'ChangePrice';

  status: ChangePriceFlowStatus = ChangePriceFlowStatus.ready;

  @Type(() => Number)
  customerId!: number;

  customer?: ICustomer | null;

  @Type(() => Date)
  offerValidTo!: Date | null;

  @Type(() => Date)
  pricesValidFrom: Date = new Date();

  @Type(() => FlowChangePriceItem)
  items: FlowChangePriceItem[] = [];

  @Type(() => Number)
  total!: number;

  @Type(() => Number)
  totalBase!: number;

  @Type(() => Number)
  totalVat!: number;

  introducingText?: string;

  concludingText?: string;

  contractText?: string;

  representativeOwn?: string | null;

  representativeCustomer?: string | null;

  paymentType?: string | null;

  transportAgreement?: string | null;

  minimumOrder?: string | null;

  /** Display-only default delivery address of the customer (not persisted). */
  deliveryPlace?: string | null;
}

export class FlowChangePriceItem
  extends BaseModel<FlowChangePriceItem, 'ChangePrice'>
  implements IFlowChangePriceItem
{
  static override readonly modelName = 'ChangePrice';

  stockItemId!: string;

  text?: string;

  note?: string;

  @Type(() => Number)
  quantity!: number;

  @Type(() => Number)
  priceBase!: number;

  @Type(() => Number)
  price!: number;

  @Type(() => Number)
  priceVat!: number;

  vatRate!: VatRateType;

  @Type(() => Number)
  sortOrder?: number;

  @Type(() => Number)
  total!: number;

  @Type(() => Number)
  totalBase!: number;

  @Type(() => Number)
  totalVat!: number;
}

export class FlowChangePricesStepData
  extends BaseFlowStepData<FlowChangePricesStepData>
  implements IFlowChangePricesStepData {}
